import ProductSize from '../product-size';
import Material from '../../material/material';

export default class WindowStickerSize extends ProductSize {
  material?: Material;

  constructor() {
    super();
    this.type = 'WindowStickerSize';
  }
}
